var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4082 17.7546L14.9977 13.3441C16.0596 11.9306 16.6328 10.2099 16.6309 8.44195C16.6309 3.92602 12.9568 0.251953 8.44085 0.251953C3.92492 0.251953 0.250854 3.92602 0.250854 8.44195C0.250854 12.9579 3.92492 16.632 8.44085 16.632C10.2088 16.6339 11.9295 16.0607 13.343 14.9988L17.7535 19.4093C17.9768 19.6089 18.268 19.7154 18.5673 19.707C18.8666 19.6986 19.1514 19.576 19.3631 19.3642C19.5749 19.1525 19.6975 18.8677 19.7059 18.5684C19.7143 18.2691 19.6078 17.9779 19.4082 17.7546ZM2.59085 8.44195C2.59085 7.28493 2.93395 6.15389 3.57676 5.19187C4.21956 4.22984 5.13321 3.48003 6.20216 3.03726C7.2711 2.59449 8.44734 2.47864 9.58213 2.70436C10.7169 2.93008 11.7593 3.48724 12.5774 4.30538C13.3956 5.12351 13.9527 6.16588 14.1784 7.30067C14.4042 8.43546 14.2883 9.6117 13.8455 10.6806C13.4028 11.7496 12.653 12.6632 11.6909 13.306C10.7289 13.9489 9.59787 14.292 8.44085 14.292C6.88991 14.2901 5.40302 13.6732 4.30633 12.5765C3.20965 11.4798 2.59271 9.9929 2.59085 8.44195Z",
    fill: "var(--grey-400)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.6ce59e1f2c7ec73529d538c2141de352.svg";
export { ForwardRef as ReactComponent };